import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CalendarLanguageService {
  constructor(private readonly translate: TranslateService, private readonly primengConfig: PrimeNGConfig) {
    this.loadTranslations()
  }


  private loadTranslations() {
    this.translate.get('primeng-calendar').subscribe(translations => {
      this.primengConfig.setTranslation({
        firstDayOfWeek: translations.FIRST_DAY_OF_WEEK,
        dayNames: translations.DAY_NAMES,
        dayNamesShort: translations.DAY_NAMES_SHORT,
        dayNamesMin: translations.DAY_NAMES_MIN,
        monthNames: translations.MONTH_NAMES,
        monthNamesShort: translations.MONTH_NAMES_SHORT,
        today: translations.TODAY,
        clear: translations.CLEAR,
        dateFormat: translations.DATE_FORMAT,
        weekHeader: translations.WEEK_HEADER
      });
    });
  }
}
